/**
 * Shared chrome constants for the layout. Kept centralised so any future
 * sub-component (MobileMenu, UserMenu, TopNav) styles the gunmetal nav
 * surface identically.
 */
export const NAVBAR_BG = '#2A3138';
export const NAVBAR_BORDER = '#1A1F24';
export const NAVBAR_MUTED = '#CBD5E1';
